import { render } from "./CalendarOutline.vue?vue&type=template&id=5fa3b324"
import script from "./CalendarOutline.vue?vue&type=script&lang=js"
export * from "./CalendarOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__